import { cn } from "@/lib/utils";
import { TASK_STATUS_STYLES } from "../mailTaskStatus";
import type { MailTaskStatus } from "../types";

type MailTaskStatusBadgeProps = {
  status: MailTaskStatus;
};

/** Whether a list row's email has been dealt with, going by its tasks. Nothing when it has none. */
export const MailTaskStatusBadge = ({ status }: MailTaskStatusBadgeProps) => {
  if (status === "none") return null;

  const { label, description, icon: Icon, className } = TASK_STATUS_STYLES[status];

  return (
    <span
      title={description}
      className={cn(
        "inline-flex shrink-0 items-center gap-1 rounded-full border px-1.5 text-[11px] font-semibold leading-4",
        className,
      )}
    >
      <Icon className="size-3" aria-hidden />
      <span className="sr-only">{description}</span>
      <span aria-hidden>{label}</span>
    </span>
  );
};
